import { render } from "./Alto.vue?vue&type=template&id=1e9fe111&scoped=true"
import script from "./Alto.vue?vue&type=script&lang=js"
export * from "./Alto.vue?vue&type=script&lang=js"

import "./Alto.vue?vue&type=style&index=0&id=1e9fe111&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9fe111"]])

export default __exports__